var _desc, _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVisa(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "51px",
    height: "32px",
    viewBox: "0 0 51 32",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "cc-visa") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "path-1",
    x: 0,
    y: 0,
    width: 51,
    height: 32,
    rx: 5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "path-3",
    x: 0,
    y: 0,
    width: 51,
    height: 32,
    rx: 5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "path-5",
    x: 0,
    y: 0,
    width: 51,
    height: 32,
    rx: 5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "path-7",
    x: 0,
    y: 0,
    width: 51,
    height: 32,
    rx: 4
  }), /*#__PURE__*/React.createElement("rect", {
    id: "path-9",
    x: 0,
    y: 0,
    width: 51,
    height: 32,
    rx: 4
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "cc-visa",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "oldcc-visa"
  }, /*#__PURE__*/React.createElement("g", {
    id: "b-link",
    fill: "#F9F9F9",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "b",
    x: 0,
    y: 0,
    width: 51,
    height: 32,
    rx: 5
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clipped"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "b"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#0067B3",
    fillRule: "nonzero",
    mask: "url(#mask-2)",
    x: 0,
    y: 0,
    width: 51,
    height: 4
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clipped"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-4",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-3"
  })), /*#__PURE__*/React.createElement("g", {
    id: "b"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#F9A42B",
    fillRule: "nonzero",
    mask: "url(#mask-4)",
    x: 0,
    y: 28,
    width: 51,
    height: 4
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clipped"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-6",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-5"
  })), /*#__PURE__*/React.createElement("g", {
    id: "b"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    mask: "url(#mask-6)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(5.000000, 10.000000)"
  }, /*#__PURE__*/React.createElement("polyline", {
    id: "Path",
    fill: "#0066B2",
    points: "16.882 12.446 13.756 12.446 15.788 0.156 18.914 0.156 16.882 12.446"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.97200762,8.55674797 L7.65937987,6.84539837 L6.56518275,1.24461789 C6.56518275,1.24461789 6.30057965,0.702701325 6.09624112,0.544520325 C5.83163803,0.339687775 5.15835787,0.155577236 5.15835787,0.155577236 L0,0.155577236 L0,0.311154472 C0,0.363954479 1.54058221,0.684092951 3.28259137,1.71134959 L6.09624112,12.4461789 L9.3788325,12.4461789 L14.5371904,0.155577236 L11.0982851,0.155577236 L7.97200762,8.55674797 Z M32.8259137,8.09001626 L34.5453664,3.42269919 L35.4832496,8.09001626 L32.8259137,8.09001626 L32.8259137,8.09001626 Z M36.264819,12.4461789 L39.2347826,12.4461789 L36.7337606,0.155577236 L34.0764247,0.155577236 C32.8974805,0.155577236 32.6074702,1.07107926 32.6695999,1.08904065 L27.8238697,12.4461789 L31.1064611,12.4461789 L31.8880305,10.579252 L35.9521912,10.579252 L36.264819,12.4461789 L36.264819,12.4461789 Z M28.1364975,3.11154472 L28.6054391,0.466731707 C28.6054391,0.5372942 27.2005939,0 25.7917894,0 C24.1540732,0 20.3960211,0.695968803 20.3208037,4.04500813 C20.3960211,7.26446895 24.807308,7.30374484 24.8539061,9.02347967 C24.807308,10.6474324 20.8504227,10.3489356 19.5392344,9.33463415 L19.0702927,12.1350244 C19.0702927,12.0603172 20.4938762,12.7573333 22.6655119,12.7573333 C24.846346,12.7573333 28.1307378,11.6230456 28.1364975,8.55674797 C28.1307378,5.33366611 23.6798924,5.03464565 23.6033951,3.57827642 C23.6798924,2.24815205 26.7857507,2.42725011 28.1364975,3.11154472",
    id: "Shape",
    fill: "#0066B2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.65937987,6.84539837 L6.56518275,1.24461789 C6.58819972,1.27160077 6.45930468,0.155577236 5.002044,0.155577236 L0,0.155577236 L0,0.311154472 C0,0.365720413 2.41314384,0.871854731 4.68941625,2.80039024 C6.93902291,4.58438419 7.65937987,6.84539837 7.65937987,6.84539837",
    id: "Path",
    fill: "#F9A533"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Clipped"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-8",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-7"
  })), /*#__PURE__*/React.createElement("g", {
    id: "a"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    strokeLinecap: "round",
    mask: "url(#mask-8)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "a-Clipped"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-10",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-9"
  })), /*#__PURE__*/React.createElement("g", {
    id: "a"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "a",
    stroke: "#E0E0E0",
    strokeWidth: 2,
    mask: "url(#mask-10)",
    x: 0,
    y: 0,
    width: 51,
    height: 32,
    rx: 4
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(-3.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-110",
    fill: "#1A1F70",
    points: "0 32 56 32 56 0 0 0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.9091739,10.1946496 L19.4581237,20.8336117 L16.5537624,20.8336117 L14.3635015,12.3428608 C14.2302028,11.8196737 14.1145361,11.6285567 13.7100555,11.408472 C13.0502619,11.0495536 11.9595395,10.7125377 11,10.5037575 L11.0655915,10.1946496 L15.7402168,10.1946496 C16.3358295,10.1946496 16.8718457,10.5917207 17.0069076,11.2791766 L18.1639268,17.4362515 L21.0227973,10.1946496 L23.9091739,10.1946496 Z M35.2889384,17.359946 C35.3005756,14.5518338 31.4123425,14.3974565 31.4391433,13.1430085 C31.4472541,12.7611279 31.8104755,12.3555784 32.6042732,12.2513649 C32.9985272,12.2001413 34.0825494,12.1602222 35.3136234,12.7279209 L35.7953327,10.4719635 C35.1344811,10.231036 34.2835555,10 33.2256288,10 C30.5102837,10 28.5989628,11.4462714 28.5827413,13.5171173 C28.5658144,15.0488792 29.947114,15.9030766 30.9884665,16.4124864 C32.058383,16.9339071 32.4180781,17.2677436 32.4134938,17.7344081 C32.4064409,18.4483589 31.5593943,18.763119 30.7698283,18.7754833 C29.3881761,18.7973858 28.5866203,18.4020811 27.9476326,18.1035712 L27.4497018,20.4347742 C28.0915107,20.7301047 29.2760359,20.9869292 30.5053467,21 C33.391018,21 35.2794171,19.5713919 35.2889384,17.359946 L35.2889384,17.359946 Z M42.4588601,20.8336117 L45,20.8336117 L42.7825857,10.1946496 L40.4368096,10.1946496 C39.9096095,10.1946496 39.4649277,10.5019911 39.2670954,10.9753677 L35.1454131,20.8336117 L38.0303791,20.8336117 L38.6030701,19.244974 L42.1280817,19.244974 L42.4588601,20.8336117 Z M39.3936939,17.0642623 L40.8398797,13.0691759 L41.672468,17.0642623 L39.3936939,17.0642623 Z M27.8347871,10.1946496 L25.5630659,20.8336117 L22.8156303,20.8336117 L25.0880568,10.1946496 L27.8347871,10.1946496 Z",
    id: "Fill-111",
    fill: "#FFFFFF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisa);
export default __webpack_public_path__ + "static/media/visa.d44f05b09a8a95d47618fd9a467a769d.svg";
export { ForwardRef as ReactComponent };